import React, { useCallback, useState, useContext } from "react";
import axios from 'axios';
import fileDownload from "js-file-download";
import Container from "react-bootstrap/Container";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import { FaDownload } from 'react-icons/fa';

import LoadingSpinner from "../Layout/LoadingSpinner";

import { SiteContext } from "../../context/SiteContext";
import { UserContext } from "../../context/UserContext";
import { useEffect } from "react";

const BatchAssignationHistory = ({ store }) => {
    const { env, csrfToken } = useContext(SiteContext);
    const { user } = useContext(UserContext);
    
    const [assignations, setAssignations] = useState([]);
    const [lastLoadTime, setLastLoadTime] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchAssignations = useCallback(
        () => {
            setLoading(true);
            axios
                .get(env.webApiBaseUrl + "/batchAssignations/by-store/" + encodeURIComponent(store), {
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                        "X-CSRF-Token": csrfToken,
                        Authorization: "Bearer " + user.token,
                    },
                    withCredentials: true,
                })
                .then((response) => {
                    setAssignations(response.data);
                    setLastLoadTime(new Date());
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    setLoading(false);
                });
        },
        [csrfToken, env.webApiBaseUrl, store, user.token]
    );

    const downloadReport = useCallback(
            (id) => {
                const url = env.webApiBaseUrl + "/batchAssignations/" + encodeURIComponent(id) + "/download";
                axios
                    .get(url, {
                        headers: {
                            "X-Requested-With": "XMLHttpRequest",
                            "X-CSRF-Token": csrfToken,
                            Authorization: "Bearer " + user.token,
                        },
                        withCredentials: true,
                        responseType: 'blob',
                    })
                    .then((response) => {
                        const fileContent = response.data;
    
                        const fecha = new Date();
                        const fechaLocalISO = fecha.getFullYear() +
                            "-" + String(fecha.getMonth() + 1).padStart(2, "0") +
                            "-" + String(fecha.getDate()).padStart(2, "0") +
                            "T" + String(fecha.getHours()).padStart(2, "0") +
                            "_" + String(fecha.getMinutes()).padStart(2, "0") +
                            "_" + String(fecha.getSeconds()).padStart(2, "0");
                        const filename = `picking-masivo-${id}-${fechaLocalISO}.csv`;
    
                        fileDownload(fileContent, filename, "text/csv", "\uFEFF");
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                    .finally(() => {
                    });
            },
            [csrfToken, env.webApiBaseUrl, user.token],
        );

    useEffect(() => {
        fetchAssignations();
    }, [fetchAssignations]);

    return (
        <Container fluid>
            <div className="w-100 h-100 p-4 border customFormBox">
                <h5>
                    Últimos 5 pickings masivos
                </h5>
                <p>
                    Actualizado: {lastLoadTime ? lastLoadTime.toLocaleString("es-CL") : "..."}
                </p>

                {loading
                ? <LoadingSpinner />
                : <Table 
                    striped  
                    hover
                    size="sm"
                >
                    <thead>
                        <tr>
                            <th width="50%">Archivo</th>
                            <th width="40%">Fecha</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                    {assignations.map((assignation, index) => 
                        <tr>
                            <td style={{ lineBreak: "anywhere" }}>
                                {assignation.uploadFilename}
                            </td>
                            <td>
                                {(new Date(assignation.createdAt)).toLocaleString('es-CL')}
                            </td>
                            <td className="text-center">
                                <Button
                                    className="m-1"
                                    size="sm"
                                    disabled={!["done", "failed"].includes(assignation.status)}
                                    onClick={() => downloadReport(assignation._id)}
                                >
                                    <FaDownload />
                                </Button>
                            </td>
                        </tr>
                    )}
                    </tbody>
                </Table>
                }
            </div>
        </Container>
    );
};

export default BatchAssignationHistory;
